import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../../components/feature/Navbar";
import Footer from "../../../components/feature/Footer";

type UserType = "Bireysel" | "Emlak Ofisi";

export default function RegisterPage() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState<UserType>("Bireysel");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);

  const validate = (): boolean => {
    const e: Record<string, string> = {};
    if (!name.trim())
      e.name =
        userType === "Bireysel"
          ? "Ad soyad zorunludur"
          : "Firma adı zorunludur";
    if (!email.trim()) e.email = "E-posta adresi zorunludur";
    if (!phone.trim()) e.phone = "Telefon numarası zorunludur";
    if (!password) e.password = "Şifre zorunludur";
    if (!confirmPassword) e.confirmPassword = "Şifre tekrarı zorunludur";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (ev: React.FormEvent) => {
    ev.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setTimeout(() => {
      localStorage.setItem(
        "auth_user",
        JSON.stringify({ email, userType, name })
      );
      setLoading(false);
      navigate("/panelim");
    }, 1100);
  };

  return (
    <div className="min-h-screen bg-surface-50">
      <Navbar />

      <main className="pt-24 md:pt-28 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-md mx-auto">
            {/* Header */}
            <div className="mb-8 text-center">
              <h1 className="text-2xl md:text-3xl font-bold text-surface-900 mb-2">
                Kayıt Ol
              </h1>
              <p className="text-sm text-surface-500">
                Ücretsiz hesap oluşturarak arsa ilanlarınızı yönetin
              </p>
            </div>

            <div className="bg-white rounded-2xl border border-surface-200 shadow-soft overflow-hidden">
              {/* Tabs */}
              <div className="flex border-b border-surface-100">
                {(["Bireysel", "Emlak Ofisi"] as const).map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => {
                      setUserType(t);
                      setErrors({});
                    }}
                    className={`flex-1 py-3.5 text-sm font-medium transition-colors relative ${
                      userType === t
                        ? "text-primary-600"
                        : "text-surface-400 hover:text-surface-600"
                    }`}
                  >
                    {t}
                    {userType === t && (
                      <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-primary-500 rounded-full" />
                    )}
                  </button>
                ))}
              </div>

              <form onSubmit={handleSubmit} className="p-5 md:p-8 space-y-5">
                {/* Name */}
                <div data-error={errors.name ? "true" : undefined}>
                  <label className="text-xs font-medium text-surface-600 mb-1.5 block">
                    {userType === "Bireysel" ? "Ad Soyad" : "Firma Adı"}
                    <span className="text-red-500"> *</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400">
                      <i className="ri-user-line" />
                    </span>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        if (errors.name)
                          setErrors((p) => ({ ...p, name: "" }));
                      }}
                      placeholder={
                        userType === "Bireysel"
                          ? "Ahmet Yılmaz"
                          : "Mega Emlak Ofisi"
                      }
                      className="w-full pl-10 pr-4 py-3 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
                    />
                  </div>
                  {errors.name && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.name}
                    </span>
                  )}
                </div>

                {/* Email */}
                <div data-error={errors.email ? "true" : undefined}>
                  <label className="text-xs font-medium text-surface-600 mb-1.5 block">
                    E-posta Adresi
                    <span className="text-red-500"> *</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400">
                      <i className="ri-mail-line" />
                    </span>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (errors.email)
                          setErrors((p) => ({ ...p, email: "" }));
                      }}
                      placeholder="ornek@email.com"
                      className="w-full pl-10 pr-4 py-3 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
                    />
                  </div>
                  {errors.email && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.email}
                    </span>
                  )}
                </div>

                {/* Phone */}
                <div data-error={errors.phone ? "true" : undefined}>
                  <label className="text-xs font-medium text-surface-600 mb-1.5 block">
                    Telefon
                    <span className="text-red-500"> *</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-surface-400">
                      +90
                    </span>
                    <input
                      type="tel"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        if (errors.phone)
                          setErrors((p) => ({ ...p, phone: "" }));
                      }}
                      placeholder="5XX XXX XX XX"
                      className="w-full pl-12 pr-4 py-3 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
                    />
                  </div>
                  {errors.phone && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.phone}
                    </span>
                  )}
                </div>

                {/* Password */}
                <div data-error={errors.password ? "true" : undefined}>
                  <label className="text-xs font-medium text-surface-600 mb-1.5 block">
                    Şifre
                    <span className="text-red-500"> *</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400">
                      <i className="ri-lock-line" />
                    </span>
                    <input
                      type={showPass ? "text" : "password"}
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        if (errors.password)
                          setErrors((p) => ({ ...p, password: "" }));
                      }}
                      placeholder="••••••••"
                      className="w-full pl-10 pr-10 py-3 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPass(!showPass)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400 hover:text-surface-600"
                    >
                      <i
                        className={
                          showPass ? "ri-eye-off-line" : "ri-eye-line"
                        }
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.password}
                    </span>
                  )}
                </div>

                {/* Confirm Password */}
                <div data-error={errors.confirmPassword ? "true" : undefined}>
                  <label className="text-xs font-medium text-surface-600 mb-1.5 block">
                    Şifre Tekrar
                    <span className="text-red-500"> *</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400">
                      <i className="ri-lock-line" />
                    </span>
                    <input
                      type={showConfirm ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        if (errors.confirmPassword)
                          setErrors((p) => ({ ...p, confirmPassword: "" }));
                      }}
                      placeholder="••••••••"
                      className="w-full pl-10 pr-10 py-3 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirm(!showConfirm)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-surface-400 hover:text-surface-600"
                    >
                      <i
                        className={
                          showConfirm ? "ri-eye-off-line" : "ri-eye-line"
                        }
                      />
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.confirmPassword}
                    </span>
                  )}
                </div>

                {/* Agreement */}
                <div data-error={errors.agreed ? "true" : undefined}>
                  <label className="flex items-start gap-2 cursor-pointer select-none">
                    <input
                      type="checkbox"
                      checked={agreed}
                      onChange={(e) => {
                        setAgreed(e.target.checked);
                        if (errors.agreed)
                          setErrors((p) => ({ ...p, agreed: "" }));
                      }}
                      className="mt-0.5 w-4 h-4 rounded border-surface-300 text-primary-500 focus:ring-primary-200 shrink-0"
                    />
                    <span className="text-xs text-surface-600 leading-relaxed">
                      <a
                        href="#"
                        rel="nofollow"
                        className="text-primary-500 hover:underline"
                      >
                        Kullanım Koşulları
                      </a>{" "}
                      ve{" "}
                      <a
                        href="#"
                        rel="nofollow"
                        className="text-primary-500 hover:underline"
                      >
                        Gizlilik Politikası
                      </a>
                      kabul ediyorum.
                    </span>
                  </label>
                  {errors.agreed && (
                    <span className="text-xs text-red-500 mt-1 block">
                      {errors.agreed}
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-500 text-white text-sm font-bold rounded-xl hover:bg-primary-600 transition-colors disabled:opacity-60"
                >
                  {loading ? (
                    <span className="flex items-center gap-2">
                      <i className="ri-loader-4-line animate-spin" />
                      Hesap oluşturuluyor...
                    </span>
                  ) : (
                    <>
                      Hesap Oluştur
                      <i className="ri-arrow-right-line" />
                    </>
                  )}
                </button>

                <div className="relative flex items-center py-2">
                  <div className="flex-grow border-t border-surface-200" />
                  <span className="shrink-0 mx-3 text-xs text-surface-400">
                    veya
                  </span>
                  <div className="flex-grow border-t border-surface-200" />
                </div>

                <p className="text-center text-sm text-surface-600">
                  Zaten hesabınız var mı?{" "}
                  <Link
                    to="/giris"
                    className="font-semibold text-primary-500 hover:underline"
                  >
                    Giriş Yapın
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}